import { CircularProgress } from '@material-ui/core';
import { useStyles } from '@webapps/styles';

const Loader = ({size}) => {
  const { css } = useStyles();

  return (
    <div
      className={css({
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      })}
    >
      <CircularProgress  size={size} />
    </div>
  );
};

export default Loader;
